import Api from '@teko/api';
import { accessTokenInterceptor, handleResponseUnauthorizedInterceptor } from '@teko/auth';

class PrivacyPolicyService {
  constructor(privacyPolicyApiUrl, platformId, language) {
    this.privacyPolicyApi = new Api(privacyPolicyApiUrl);
    this.platformId = platformId;
    this.privacyPolicyApi.addInterceptor(accessTokenInterceptor);
    this.privacyPolicyApi.addInterceptor((request) => {
      request.headers.set("Accept-Language", language || "*");
    });
    this.privacyPolicyApi.addResponseInterceptor(handleResponseUnauthorizedInterceptor);
  }
  async getPolicies(policyFilter) {
    var _a;
    const { data } = await this.privacyPolicyApi.get("/users/policies", {
      params: { sellerPlatformId: this.platformId, policyFilter }
    });
    return ((_a = data.data) == null ? void 0 : _a.policies) || [];
  }
  async submitPolicies(policies) {
    await this.privacyPolicyApi.post("/users/policies", {
      submitPolicies: policies
    });
  }
}

export { PrivacyPolicyService };
